import {
    MODAL_VENDOR_KEY_VALUE,
    MODAL_VENDOR_INPUT_EMPCODE,
    MODAL_VENDOR_INPUT_EMPNAME,
    MODAL_VENDOR_SET_RESULT
} 
from '../actions/actionTypes';

const initialState = {
    key_table: null,
    key_vendorCode: null,
    key_vendorName: null,
    q_vendorCode: null,
    q_vendorName: null,
    result_vendors:[],
};

function ModalVendorRedux(state = initialState, action) {
    
    switch (action.type) {
        case MODAL_VENDOR_KEY_VALUE:
            return {
                ...state,
                key_table : action.table,
                key_vendorCode: action.vendorCode,
                key_vendorName: action.vendorName
            };
        case MODAL_VENDOR_INPUT_EMPCODE:
                return {
                    ...state,
                    q_vendorCode: action.value
                };
        case MODAL_VENDOR_INPUT_EMPNAME:    
        return {
                ...state,
                q_vendorName: action.value
            };
        case MODAL_VENDOR_SET_RESULT:
            return {
                ...state,
                result_vendors: action.value
            };
        default:
            return state;
    }
}

export default ModalVendorRedux;